<template>
  <v-layout row wrap>
    <v-flex>     
      <v-layout row>
        <v-flex xs12 class="px-1 pt-4">
          <h2 class="display-1 white--text font-weight-medium">{{ gewerk.name }} <span class="font-weight-light">Innungsfachbetriebe finden</span></h2></v-flex>
      </v-layout>
        <v-layout row wrap>
          <v-flex
            xs12
            
            text-xs-center
            layout
            align-center
            justify-center
            class="mb-0 mt-4 mb-4"
            id="scrollheadline"
          >
            <v-layout row wrap>
              <v-flex xs12 sm12 md6>
                <v-flex
                  xs12
                  sm12
                  offset-sm0
                  offset-md0
                  xmd4
                  xlg5
                  text-xs-center
                  layout
                  key="suchnachstadt"
                >
                  <v-autocomplete
                    v-bind:items="this.$store.getters.fetchBetriebe.staedte"
                    item-value="id"
                    v-model="Stadt"
                    required
                    solo
                    label="Stadt auswählen"
                    clearable
                    :loading="isLoading"
                    :browser-autocomplete="autoCompleteHackTwo"
                    prepend-inner-icon="location_searching"
                    no-data-text="Stadt nicht gefunden.."
                    class="mx-1 stadtbox"
                    xv-validate="'required'"
                    v-validate="{ required: !plzsuche }"
                    xvalidate-on-blur
                    data-vv-name="Stadt"
                    @change="Postleitzahl = ''; changeStadt(Stadt)"
                    :error-messages="errors.collect('Stadt')"
                    :class="{ invalid: errors.has('Stadt') }"
                    @keyup.enter="validateForm()"
                  ></v-autocomplete>
                </v-flex>
              </v-flex>
               <v-flex xs12 sm12 md6>
                 <v-layout row>
                   <v-flex xs6>
                      <v-btn
                        class="mt-0 mr-0 accent"
                        large
                        @click="validateForm()"
                        type="submit"
                        prepend-inner-icon="drafts"
                        :loading="busy"
                        style="height: 48px;"
                        >{{ gewerk.name }} finden
                        <v-icon right large>search</v-icon>
                      </v-btn>
                    </v-flex>
                 </v-layout>    
                </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'
// import { mapActions } from 'vuex'

const dict = {
  custom: {
    Stadt: {
      required: 'Bitte einen Standort auswählen'
    },
    Leistung: {
      required: 'Bitte eine Leistung auswählen'
    },
    Postleitzahl: {
      required: 'Bitte eine PLZ auswählen'
    }
  }
}

export default {
  components: {
  },
  props: ['gewerk'],
  data: () => ({

    isLoading: false,
    busy: false,
    Leistung: [],
    showinfos: true,
    select: [],
    HackOne: 'das2das',
    autoCompleteHackTwo: 'autocompletefail2',
    expression: {
      required: true
    },
    Stadt: null,
    search: null,
    range: 'Lokal',
    loading: false,
    busymap: false,
    Postleitzahl: '',
    result: false,
    zeigekarte: false,
    plzsuche: false,
    radiuswahl: 0,
    betriebslist: [],
    ranges: ['Lokal', 'Überregional'],

    // staedte: ['Bottrop', 'Dinslaken', 'Dorsten', 'Duisburg', 'Düsseldorf', 'Emmerich am Rhein', 'Erkrath', 'Essen'],
    leistungenleer: [],
    staedteleer: [],
    DataisLoading: false
  }),
  computed: {
    randomAutocomplete: function () {
      return Math.random()
        .toString(36)
        .substr(2, 9)
    },
    radiuswert: function () {
      return this.radien[this.radiuswahl]
    }
  },
  mounted: function () {
    this.checkVuexState()
  },
  created () {
    // this.neuGEOIP();
  },
  watch: {
    // search (val) {
    //   console.log('search eval')
    //   if (this.$store.getters.fetchBetriebe.staedte.length > 0) return
    //   this.getStartseiteDataVuex()
    // }
  },
  methods: {
    // setHeimatstadtMethod: function () {
    //   if (this.$store.state.landing.HeimatStadt) {
    //     this.Stadt = this.$store.state.landing.HeimatStadt
    //     console.log('heimatstadt set: ' + this.Stadt)
    //   }
    // },
    setRendered: function () {
      window.IS_RENDERED = true
    },
    radiuschange: function () {
      this.radiuswahl = ++this.radiuswahl % this.radien.length
      return this.radien[this.radiuswahl]
    },
    PlzSucheChange: function () {
      this.plzsuche = !this.plzsuche
    },
    getLeistungen: function () {
      this.isLoading = true
      const self = this
      axios
        .get('/api/v1/leistungnachgewerk/' + self.gewerk.id)
        .then(resp => {
          // console.log(resp)
          self.staedteleer = resp.data.staedte
          self.leistungenleer = resp.data.leistungen
        })
        .catch(err => {
          console.log(err)
          this.isLoading = false
        })
        .finally(() => (this.isLoading = false))
    },
    async getStartseiteDataVuex () {
      this.isLoading = true
      await this.$store.dispatch('getStartseiteData').then(resp => {
        // console.log('got data')
      })
      .catch(err => {
        console.log(err)
      })
      this.isLoading = false
    },
    busyswitch: function () {
      this.$emit('busy', true)
      this.busy = false
    },
    checkVuexState: function () {
      if (this.$store.getters.fetchBetriebe.staedte.length < 1) {
        this.getStartseiteDataVuex()
      }
      if (this.$store.getters.fetchHeimatStadt) {
        this.Stadt = this.$store.getters.fetchHeimatStadt
      }
    },
    scrollhochmobile: function () {
      if (this.$vuetify.breakpoint.name === 'xs') {
        this.$vuetify.goTo('#scrollheadline')
      }
    },
    async vuexBetriebe () {
      if (this.Stadt || this.Postleitzahl) {
        this.busy = true
        this.showinfos = false
      // const suchbegriff = this.leistungenleer.find(leistungobject => leistungobject.id === this.Leistung)
        var payload = {
          leistung: this.gewerk.defaultleistung_id,
          standort: this.Stadt,
          postleitzahl: this.Postleitzahl,
          plzsuche: this.plzsuche,
          range: this.range
        // standort: this.$store.state.landing.HeimatStadt
        // suchbegriff: suchbegriff.text
        }
        await this.$store.dispatch('fetchBetriebe', payload).then(() => {
          if (!this.$store.getters.fetchBetriebe.error) {
            this.$router.push({
              name: 'handwerker'
            })
          }
        })
        this.busy = false
        this.$emit('busy', false)
      } else {
        this.plzsuche = false
        console.log('bitte location wählen')
      }
    },
    // ...mapActions({
    //   changeHeimatStadt: 'setStadtGewerk'
    // }),
    loescheBetriebe () {
      this.$store.dispatch('loescheBetriebe')
    },
    changeStadt () {
      this.$store.dispatch('setStadtGewerk', this.Stadt)
    },
    validateFormForMap () {
      this.$validator.localize('de', dict)
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line
          this.showinfos = false;
          this.vuexBetriebeMap()
          return
        }
      })
    },
    validateForm () {
      this.$validator.localize('de', dict)
      this.$validator.validateAll().then(result => {
        if (result) {
          // eslint-disable-next-line
          this.showinfos = false;
          this.vuexBetriebe()

          return
        }
      })
    }
  }
}
</script>

<style>
.start_top {
  margin-bottom: 0;
  padding: 0;
  font-weight: bold;
  font-family: "Work Sans", sans-serif !important;
}
.v-messages__message {
  color: #fff !important;
  font-size: 16px;
}
.headline {
  font-family: "Work Sans", sans-serif;
}
.leistungfett {
  font-weight: bold;
}
.leistungfetthintergrund {
  background-color: blueviolet;
}
.nichtheadline {
  font-size: 8px;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
.v-input__icon--append-outer .v-icon {
  color: white !important;
}
.stadtbox.v-messages__message,
.stadtbox .v-messages__message {
  color: #ffffff !important;
  caret-color: #fff !important;
}
</style>
